import React from 'react'
import style from './style.module.less'
import { withRouter } from 'react-router'
import {
  LIST_PATH,
  DETAIL_PATH
} from '@merchant-backend/support-center/src/constants'
import Api from '@api/supportCenter'

const Support = ({ location }) => {
  const [list, setList] = React.useState([])
  const [catalogId, setCatalogId] = React.useState(-1)
  const [catalogTitle, setCatalogTitle] = React.useState('')

  const _getUrl = () => {
    const removeParamsProtocol = window.location.href.replace(
      /(http|https):\/\//i,
      ''
    )
    const removePort = removeParamsProtocol.replace(/:[0-9]*/i, '')
    const index = removePort.indexOf('?')
    const url = index === -1 ? removePort : removePort.slice(0, index)
    return url
  }

  React.useEffect(
    () => {
      _getYouLikeList(_getUrl())
      _getRelateCategory(_getUrl())
    },
    [location.pathname]
  )

  const _getRelateCategory = async url => {
    const { success, data } = await Api.getRelateCategory({ url })
    if (success) {
      setCatalogId(data.catalogId)
      setCatalogTitle(data.catalogTitle)
    }
  }

  const _getYouLikeList = async url => {
    const { success, data } = await Api.getYouLikeList({ url })
    if (success) {
      setList(data)
    }
  }

  return catalogId !== -1 ? (
    <div className={style.support}>
      {!!list.length && (
        <div className={style.card}>
          <div className={style.container}>
            <div className={style.title}>
              <span>
                <img
                  src="https://qnm.hunliji.com/FrC5By2huf1OHoj2nw26Acuda2rk"
                  width="24px"
                  height="24px"
                />猜你想问
              </span>
            </div>
            <ul className={style.suggest}>
              {list.map(item => (
                <li
                  onClick={() =>
                    window.open(
                      `${window.location.origin +
                        window.location.pathname}#${DETAIL_PATH}/${item.id}`
                    )
                  }
                  key={item.id}
                  className={style.item}
                >
                  <i className={style.round} />
                  <span className={style.text}>{item.title}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
      <a
        onClick={() => {
          const url =
            window.location.origin +
            window.location.pathname +
            '#' +
            (catalogId ? `${LIST_PATH}/${catalogId}` : '/supportCenter/home')
          window.open(catalogId ? url + `?title=${catalogTitle}` : url)
        }}
        className={style.img}
      />
    </div>
  ) : null
}

export default withRouter(Support)
